// This file maps state to stores, and also exposes a fetchData function to
//  fetch all the data needed to render the smart component
import CommonStore from '@src/stores/CommonStore';

/**
 * These are the stores the container will subscribe to, the getStateFromStores()
 * below runs again if the stores mentioned here emit a change
 * @type {Array}
 */
export const listenToStores = [CommonStore];

/**
 * Maps objects from the store to the local container
 * We fetch different values from the various stores and then assign them
 * here so that they're available as props to the container component
 * @return {[type]} [description]
 */
export function getStateFromStores() {
  const metatags = CommonStore.getMetaTags();
  return {
    domain: metatags.domain,
    supportedLanguages: CommonStore.getSupportedLanguages(),
    allLanguages: CommonStore.getAllLanguages(),
  };
}

/**
 * These functions are exported from here rather than being imported directly
 * into the containers to keep a proper separation and maintain the ability
 * to refactor easily later if needed. All the functions are then available as
 * maps.*
 */
export {
  updateCurrentLanguage,
  addLanguageToBot,
} from 'actions/LanguageActions';
export { closeComponentModal, createAlert } from '@src/actions/BotActions';
